import React, { useState, useRef,useEffect  } from 'react'
import Offcanvas from 'react-bootstrap/Offcanvas';
import { usePubSub } from "@videosdk.live/react-sdk";
import { Dropdown } from "react-bootstrap";
import toast from "react-hot-toast";

const Chat = ({ show, handleClose, user_name, setUnreadCount }) => {
    // const { publish, messages, } = usePubSub("CHAT");
    const lastReadTimeRef = useRef(null);
    

const { publish, messages } = usePubSub("CHAT", {
    onMessageReceived: (msg) => {
        if (msg.senderName === user_name) return;

        const isUnread =
            !lastReadTimeRef.current ||
            new Date(msg.timestamp) > new Date(lastReadTimeRef.current);

        if (isUnread && !show) {
            setUnreadCount(prev => prev + 1);

            setPopupMsg({
                sender: msg.senderName,
                text: msg.message
            });

            setTimeout(() => setPopupMsg(null), 3000);
        }

        if (audioRef.current) {
            audioRef.current.currentTime = 0;
            audioRef.current.play().catch(() => {});
        }
    }
});

    // State to store the user typed message
    const [message, setMessage] = useState("");
    const audioRef = useRef(null);
    const [popupMsg, setPopupMsg] = useState(null);
    // const [lastReadTime, setLastReadTime] = useState(null);
    

    const handleSendMessage = () => {
        if (message.trim()) {
            publish(message.trim(), { persist: true });
            setMessage("");
        }
    };

   const initialLoadRef = useRef(true);

useEffect(() => {
    if (!messages?.length) return;

    if (initialLoadRef.current) {
        let count = 0;

        messages.forEach((msg) => {
            if (
                msg.senderName !== user_name &&
                (!lastReadTimeRef.current ||
                    new Date(msg.timestamp) > new Date(lastReadTimeRef.current))
            ) {
                count++;
            }
        });

        if (!show) {
            setUnreadCount(count);
        }

        initialLoadRef.current = false;
    }
}, [messages]);

useEffect(() => {
    if (show && messages?.length > 0) {
        const lastMsg = messages[messages.length - 1];

        lastReadTimeRef.current = lastMsg.timestamp; 
        setUnreadCount(0);
    }
}, [show, messages]);

    const linkifyText = (text) => {
        const urlRegex = /(\b(?:https?:\/\/|www\.)[^\s]+)/gi;

        return text.split(urlRegex).map((part, index) => {
            if (urlRegex.test(part)) {
                const href = part.startsWith("http") ? part : `https://${ part }`;
                return (
                    <a
                        key={index}
                        href={href}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: '#FFD700', textDecoration: 'underline' }}
                    >
                        {part}
                    </a>
                );
            }
            return part;
        });
    };

    if (!audioRef.current) {
        audioRef.current = new Audio("/notification.mp3");
    }

    return (
        <>
            {popupMsg && (
                <div
                    style={{
                        position: "fixed",
                        bottom: "20px",
                        right: "20px",
                        zIndex: 999999,
                        cursor: "pointer"
                    }}
                    onClick={() => {
                        handleClose();
                        setPopupMsg(null);
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            background: "#ffffff", 
                            color: "#111", 
                            padding: "10px 12px",
                            borderRadius: "8px",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.15)", 
                            minWidth: "260px",
                            maxWidth: "320px",
                            border: "1px solid #e0e0e0" 
                        }}
                    >

                       
                        <div
                            style={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "50%",
                                background: "#25D366", 
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontWeight: "600",
                                fontSize: "14px",
                                color: "#fff",
                                flexShrink: 0
                            }}
                        >
                            {popupMsg.sender?.charAt(0).toUpperCase()}
                        </div>

                        <div style={{ flex: 1 }}>
                            <div
                                style={{
                                    fontWeight: "500",
                                    fontSize: "14px",
                                    marginBottom: "2px"
                                }}
                            >
                                {popupMsg.sender}
                            </div>

                            <div
                                style={{
                                    fontSize: "13px",
                                    color: "#555", 
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap"
                                }}
                            >
                                {popupMsg.text}
                            </div>
                        </div>

                        {/* ⏱ Time */}
                        <div
                            style={{
                                fontSize: "11px",
                                color: "#999",
                                alignSelf: "flex-start"
                            }}
                        >
                            now
                        </div>

                    </div>
                </div>
            )}


            <Offcanvas className="custom-offcanvas bg-dark text-light" show={show} onHide={handleClose} placement="end" style={{ borderRadius: '10px', zIndex: '99999' }}>
                <Offcanvas.Header style={{ borderBottom: '1px solid #fff' }} >
                    <Offcanvas.Title>Chat</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div style={{ height: '90%', overflowY: 'auto' }}>
                        {/* <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'end', alignItems: 'end', overflowY: 'auto' }}> */}

                        {messages?.map((message) => {

                            return (
                                <div className='video-meet-sec' style={{ overflowWrap: 'anywhere' }}><div
                                    className={`col-lg-12 mt-3 d-flex justify-content-${ message.senderName === user_name ? "end" : "start" }`}
                                    key={message.id}
                                >

                                    <div
                                        className={`message px-3 py-0 ${ message.senderName == user_name ? "my-msg" : "other-msg" }`}
                                    >
                                        <small className='text-light text-wrap '>{message.senderName}</small>
                                        <p className="mb-0 text-light text-wrap">{linkifyText(message.message)}</p>


                                        <span className="msg-date d-flex justify-content-end" style={{ fontSize: '12px' }}>

                                            {message.timestamp
                                                ? new Date(message.timestamp).toLocaleTimeString([], {
                                                    hour: "2-digit",
                                                    minute: "2-digit",
                                                })
                                                : ""}
                                        </span>

                                    </div>

                                </div></div>

                            );
                        })}
                        {/* </div> */}

                    </div>

                    <div style={{ height: '10%', width: '100%', display: 'flex', gap: '10px', alignItems: 'end', justifyContent: 'start' }}>
                        <input
                            className="p-1"
                            style={{ width: '85%' }}
                            placeholder='Write your message'
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' && message.trim()) {
                                    handleSendMessage();
                                }
                            }}
                        />
                        <Dropdown>
                            <Dropdown.Toggle className="control-btn">
                                <i className="fa fa-smile-o"></i>
                            </Dropdown.Toggle>

                            <Dropdown.Menu style={{ maxHeight: "200px", overflowY: "auto" }}>
                                <Dropdown.Item onClick={() => setMessage((prev) => prev + "😂")}>😂</Dropdown.Item>
                                <Dropdown.Item onClick={() => setMessage((prev) => prev + "🤣")}>🤣</Dropdown.Item>
                                <Dropdown.Item onClick={() => setMessage((prev) => prev + "😊")}>😊</Dropdown.Item>
                                <Dropdown.Item onClick={() => setMessage((prev) => prev + "😍")}>😍</Dropdown.Item>
                                <Dropdown.Item onClick={() => setMessage((prev) => prev + "😘")}>😘</Dropdown.Item>
                                <Dropdown.Item onClick={() => setMessage((prev) => prev + "😎")}>😎</Dropdown.Item>
                                <Dropdown.Item onClick={() => setMessage((prev) => prev + "🤔")}>🤔</Dropdown.Item>
                                <Dropdown.Item onClick={() => setMessage((prev) => prev + "😢")}>😢</Dropdown.Item>
                                <Dropdown.Item onClick={() => setMessage((prev) => prev + "😭")}>😭</Dropdown.Item>
                                <Dropdown.Item onClick={() => setMessage((prev) => prev + "😡")}>😡</Dropdown.Item>

                                <Dropdown.Item onClick={() => setMessage((prev) => prev + "👍")}>👍</Dropdown.Item>
                                <Dropdown.Item onClick={() => setMessage((prev) => prev + "👎")}>👎</Dropdown.Item>
                                <Dropdown.Item onClick={() => setMessage((prev) => prev + "👏")}>👏</Dropdown.Item>
                                <Dropdown.Item onClick={() => setMessage((prev) => prev + "🙏")}>🙏</Dropdown.Item>
                                <Dropdown.Item onClick={() => setMessage((prev) => prev + "👌")}>👌</Dropdown.Item>
                                <Dropdown.Item onClick={() => setMessage((prev) => prev + "🤝")}>🤝</Dropdown.Item>
                                <Dropdown.Item onClick={() => setMessage((prev) => prev + "💪")}>💪</Dropdown.Item>

                                <Dropdown.Item onClick={() => setMessage((prev) => prev + "🔥")}>🔥</Dropdown.Item>
                                <Dropdown.Item onClick={() => setMessage((prev) => prev + "🎉")}>🎉</Dropdown.Item>
                                <Dropdown.Item onClick={() => setMessage((prev) => prev + "❤️")}>❤️</Dropdown.Item>
                                <Dropdown.Item onClick={() => setMessage((prev) => prev + "💔")}>💔</Dropdown.Item>
                                <Dropdown.Item onClick={() => setMessage((prev) => prev + "💯")}>💯</Dropdown.Item>

                                <Dropdown.Item onClick={() => setMessage((prev) => prev + "✔️")}>✔️</Dropdown.Item>
                                <Dropdown.Item onClick={() => setMessage((prev) => prev + "❌")}>❌</Dropdown.Item>
                                <Dropdown.Item onClick={() => setMessage((prev) => prev + "⭐")}>⭐</Dropdown.Item>
                                <Dropdown.Item onClick={() => setMessage((prev) => prev + "🌟")}>🌟</Dropdown.Item>
                                <Dropdown.Item onClick={() => setMessage((prev) => prev + "⚡")}>⚡</Dropdown.Item>
                                <Dropdown.Item onClick={() => setMessage((prev) => prev + "🎯")}>🎯</Dropdown.Item>
                                <Dropdown.Item onClick={() => setMessage((prev) => prev + "🚀")}>🚀</Dropdown.Item>
                                <Dropdown.Item onClick={() => setMessage((prev) => prev + "💡")}>💡</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>

                        {/* <button className='btn btn-primary ms-3 py-1' onClick={handleSendMessage}>Send Message</button> */}
                        <i class="bi bi-send-fill" onClick={handleSendMessage} style={{ width: '15%', fontSize: '1.8rem' }}></i>
                    </div>

                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default Chat